import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DSBottomNav } from '../design-system/primitives';

// My Membership's tab bar. All of the construction lives in DSBottomNav; this is
// only which tabs exist, which path lights each one up, and what the centre
// action does.
//
// The middle slot is not a tab. It is the membership card, and it opens a sheet
// over whatever tab you are on rather than navigating: the card is used at the
// door under time pressure, so it has to be one tap from a cold open on every
// tab rather than living at the bottom of the longest one.
//
// Tab order is Home, Standing, card, Profile, Assigned. Assigned sits outermost
// on purpose - it is the slot that grows a count, and a count that moves the
// things either side of it as it appears is worse than one at the end.
const TABS = [
  {
    key: 'home',
    path: '/my-membership',
    icon: 'home',
    label: 'Home',
    match: (p) => p === '/my-membership' || p === '/my-membership/credit'
  },
  {
    key: 'standing',
    path: '/my-membership/standing',
    icon: 'trophy',
    label: 'Standing',
    match: (p) => p === '/my-membership/standing' || p === '/my-membership/badges'
  },
  {
    key: 'profile',
    path: '/my-membership/profile',
    icon: 'user',
    label: 'Profile',
    match: (p) => p === '/my-membership/profile' || p === '/my-membership/tech'
  },
  {
    key: 'assigned',
    path: '/my-membership/assigned',
    icon: 'clipboard',
    label: 'Assigned',
    match: (p) => p === '/my-membership/assigned',
    countKey: 'assignedCount'
  }
];

function MyAccountBottomNav({ onOpenCard, cardOpen = false, assignedCount = 0, cardLabel = 'Membership card' }) {
  const location = useLocation();
  const navigate = useNavigate();
  const counts = { assignedCount };

  return (
    <DSBottomNav
      ariaLabel="My membership"
      items={TABS.map((tab) => ({
        key: tab.key,
        icon: tab.icon,
        label: tab.label,
        active: tab.match(location.pathname),
        onClick: () => navigate(tab.path),
        count: tab.countKey ? counts[tab.countKey] : 0,
        // DSCountIndicator prefixes the number itself, so this is the noun only:
        // "12 items waiting on you".
        countLabel: tab.countKey ? 'items waiting on you' : undefined
      }))}
      centerAction={{
        icon: 'qr',
        label: cardOpen ? 'Close membership card' : cardLabel,
        active: cardOpen,
        onClick: onOpenCard
      }}
    />
  );
}

export default MyAccountBottomNav;
